
import React, { useState, useEffect } from 'react'
import { Button, Form, Select, Spin, Alert } from 'antd'
import axios from 'axios'
import Message from '@beisen-phoenix/message'
import { getUrlParams } from '../../../utils'
import './index.scss'

const { Option } = Select

const Refuse = () => {
    const [loading, setLoading] = useState(true)//loading
    const [submitLoading, setSubmitLoading] = useState(false)//submitLoading
    const [formDisabled, setFormDisabled] = useState(false)//form是否禁用
    const [isInternshipIdAvailable, setIsInternshipIdAvailable] = useState(true)//链接是否有效
    const [refuseReasonList, setRefuseReasonList] = useState([])//拒绝实习列表

    const {
        applyId,//申请id
        internshipId,//实习邀请id
        signValue,//MD5校验信息
    } = getUrlParams()


    useEffect(() => {
        //获取链接是否有效
        const getIsInternshipIdAvailable = axios.post('/api/jingShun/getInfoIfInternshipIdAvailable', {
            applyId,
            internshipId,
            signValue
        })
            .then(res => {
                const {
                    code,
                    message,
                    data: {
                        isInternshipIdAvailable,
                    }
                } = res.data
                if (code === '200') {
                    setIsInternshipIdAvailable(isInternshipIdAvailable)
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message });
                setIsInternshipIdAvailable(isInternshipIdAvailable)
            })

        //获取可选的拒绝实习原因
        const getRefuseReason = axios.get('/api/jingShun/getRefuseReason')
            .then(res => {
                const {
                    code,
                    message,
                    data
                } = res.data
                if (code === '200') {
                    Array.isArray(data) && setRefuseReasonList(data)
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message })
            })

        Promise.allSettled([getIsInternshipIdAvailable, getRefuseReason]).then(() => {
            setLoading(false)
        })
    }, [])

    //拒接实习邀请
    const onFinish = (values) => {
        setSubmitLoading(true)
        axios.post('/api/jingShun/refuseInternship', {
            applyId,
            internshipId,
            signValue,
            refuseReason: values.refuseReason
        })
            .then(res => {
                const {
                    code,
                    message,
                } = res.data
                if (code === '200') {
                    setFormDisabled(true)
                    Message.success({ message: message || '提交成功' })
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message })
            }).finally(() => setSubmitLoading(false))
    }

    return (
        <Spin spinning={loading}>
            {
                isInternshipIdAvailable ?
                    <div className='refuse-internship'>
                        <div className='refuse-internship-header'>
                            拒绝实习
                        </div>
                        <Form
                            disabled={formDisabled}
                            className='refuse-internship-body'
                            onFinish={onFinish}
                        >
                            <Form.Item
                                className='refuse-reason-item'
                                label="拒绝原因"
                                name="refuseReason"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择拒绝原因',
                                    },
                                ]}
                            >

                                <Select allowClear className='refuse-reason'>
                                    {refuseReasonList.map(v => (
                                        <Option key={v} value={v}>
                                            {v}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Button className='refuse-internship-submit' block type="primary" size="large" htmlType="submit" loading={submitLoading}>
                                提交
                            </Button>
                        </Form>
                    </div>
                    :
                    <Alert message='链接已失效' type="warning" showIcon />
            }
        </Spin>
    )
}

export default Refuse